import { callApiToServer } from '../../callApi';

export async function changeStatus(
  authtoken,
  currencyId,
  status
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
      currencyId: currencyId,
      flag: status
    });

    let endUrl = "v1/auth/change-currency-status";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
